import React from 'react';
import cn from 'classnames';

const CardLoader = ({ contentList, className }) => {
  const keys = contentList.map((obj, index) => { return index + 1; });
  const skeletonList = contentList && contentList.map((obj, index) => (
    <div className={obj.className} key={keys[index]}>
      <div style={obj.style} />
    </div>
  ));
  return (
    <div className={cn('skeletonList', className)}>
      {skeletonList}
    </div>
  );
};

export default CardLoader;
